import { Icon } from '@iconify/react';
import ButtonWithEnter from '../components/button-with-enter';
import { SetupStepShell } from '../components/setup-step-shell';
import { useSetupStore } from '@up2promo-setup-frontend/core/store/setup.store';
import type { ProductType } from '@up2promo-setup-frontend/core/types/product-type.enum';
import { dictByType } from '@up2promo-setup-frontend/core/utils/dict-by-type';
import { fadeInUp } from '@up2promo-setup-frontend/ui/animations/fade-in-up.animation';
import { useDictionary } from '@up2promo-setup-frontend/ui/providers/dictionary.provider';
import { motion } from 'motion/react';

export default function CongratsPage() {
  const translations = useDictionary();

  const type = useSetupStore((state) => state.type);
  const targetLink = useSetupStore((state) => state.targetLink);
  const description = dictByType(
    translations.pages.congratsStep.descriptionByType,
    type as ProductType,
  );
  const buttonLabel = dictByType(
    translations.pages.congratsStep.buttonByType,
    type as ProductType,
  );

  return (
    <SetupStepShell>
      <div className="flex flex-col gap-2 sm:gap-3">
        <Icon
          icon="ix:cloud-success"
          className="text-[5rem] text-foreground sm:text-[6rem] md:text-[7rem]"
        />
        <motion.h1
          custom={0}
          initial="hidden"
          animate="visible"
          variants={fadeInUp}
          className="text-2xl font-semibold tracking-tight text-foreground text-balance md:text-3xl lg:text-4xl"
        >
          {translations.pages.congratsStep.title}
        </motion.h1>
        <motion.p
          custom={1}
          initial="hidden"
          animate="visible"
          variants={fadeInUp}
          className="max-w-prose text-sm text-foreground/70 text-pretty md:text-base"
        >
          {description}
        </motion.p>
        <motion.div
          custom={2}
          initial="hidden"
          animate="visible"
          variants={fadeInUp}
        >
          <ButtonWithEnter asChild text={buttonLabel}>
            <a
              href={targetLink || '#'}
              target="_blank"
              rel="noopener noreferrer"
            >
              {buttonLabel}
            </a>
          </ButtonWithEnter>
        </motion.div>
      </div>
    </SetupStepShell>
  );
}
